module.exports = __webpack_public_path__ + "img/南津古渡.cb659f7d.jpg";